export enum MovieUserStatus {
  ALREADY_WATCHED = "already_watched",
  WANT_TO_WATCH = "want_to_watch",
  DONT_WANT_TO_WATCH = "dont_want_to_watch",
  WATCHED_AND_LIKED = "watched_and_liked",
  WATCHED_AND_DISLIKED = "watched_and_disliked",
  NONE = "none",
}
